import { QueryClient, QueryFunction } from "@tanstack/react-query";

const envBaseUrl = import.meta.env.VITE_API_BASE_URL || "https://iafacilback-c0hng3fahxgdd0bk.canadacentral-01.azurewebsites.net/";
const API_BASE_URL =
  envBaseUrl && !envBaseUrl.startsWith("http") && !envBaseUrl.startsWith("/")
    ? `http://${envBaseUrl}`
    : envBaseUrl;

async function throwIfResNotOk(res: Response) {
  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
}

export async function apiRequest(
  method: string,
  path: string,
  data?: unknown | undefined,
): Promise<Response> {
  const url = `${API_BASE_URL}${path}`;
  const res = await fetch(url, {
    method,
    headers: {
      ...(data ? { "Content-Type": "application/json" } : {}),
      Accept: 'application/json',
    },
    body: data ? JSON.stringify(data) : undefined,
    credentials: "include",
  });

  return res;
}

type UnauthorizedBehavior = "returnNull" | "throw";

const defaultQueryFn: QueryFunction = async (context) => {
  const { queryKey, meta } = context;
  const path = queryKey[0] as string;

  const unauthorizedBehavior = (meta?.on401 as UnauthorizedBehavior) || "throw";

  const res = await apiRequest('GET', path);

  if (unauthorizedBehavior === "returnNull" && res.status === 401) {
    return null;
  }

  await throwIfResNotOk(res);
  return await res.json();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
